/**
 * UO's classic view is a 2:1 *dimetric* projection, not a true isometric one.
 * One tile step is 22px horizontally and 22px vertically, and Z height shifts a
 * tile up the screen by ~4px per unit. See docs/ROADMAP.md ("landmines").
 *
 * This module is the single source of truth for that mapping. It is pure and
 * accepts fractional tile coordinates so the renderer can interpolate a mobile
 * smoothly between tiles without bespoke math at the call site.
 */

/** Half a tile's width/height in screen pixels (a single grid step). */
export const TILE_HALF = 22;

/** Screen-Y shift per unit of tile Z (elevation). */
export const Z_STEP = 4;

export interface ScreenPoint {
  x: number;
  y: number;
}

export function tileToScreen(tileX: number, tileY: number, tileZ = 0): ScreenPoint {
  return {
    x: (tileX - tileY) * TILE_HALF,
    y: (tileX + tileY) * TILE_HALF - tileZ * Z_STEP,
  };
}
